import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input } from 'semantic-ui-react'

import moment from 'moment'
import axios from 'axios'

class SchoolYearsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      code: '',
      startDate: '',
      endDate: '',
      showModal: false,
      schoolYearId: '',
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      oct: 0,
      nov: 0,
      dec: 0,
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      total: 0,
      forSubmission: true
    };
  }

  handleChange = (e, { name, value }) => {
    let total=0;
    const changedNumber = isNaN(parseInt(value)) ? 0 : parseInt(value);
    const months = ['jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec', 'jan', 'feb', 'mar', 'apr', 'may'];
    months.map((month, index) => {
      if(month !== name) {
        total = parseInt(total) + parseInt(this.state[month])
      }
      return true;
    })
    total = parseInt(total) + changedNumber;
    this.setState({total: total, [name]: value})
  }

  handleSubmit = () => {
    const data = {
      junDays: this.state.jun,
      julDays: this.state.jul,
      augDays: this.state.aug,
      sepDays: this.state.sep,
      octDays: this.state.oct,
      novDays: this.state.nov,
      decDays: this.state.dec,
      janDays: this.state.jan,
      febDays: this.state.feb,
      marDays: this.state.mar,
      aprDays: this.state.apr,
      mayDays: this.state.may,
      totalDays: this.state.total,
    };

    // this.props.handleUpdate(data,this.state.schoolYearId);

    const url = process.env.REACT_APP_URL+'/schoolYears/'+this.state.schoolYearId+'/days';
    const method = this.state.forSubmission ? 'post' : 'put';
    axios
      .request({
        method: method,
        url: url,
        data: data
      })
      .then(response => {
        this.setState({
          jun: response.data.junDays,
          jul: response.data.julDays,
          aug: response.data.augDays,
          sep: response.data.sepDays,
          oct: response.data.octDays,
          nov: response.data.novDays,
          dec: response.data.decDays,
          jan: response.data.janDays,
          feb: response.data.febDays,
          mar: response.data.marDays,
          apr: response.data.aprDays,
          may: response.data.mayDays,
          total: response.data.totalDays,
          forSubmission: false
        })
      })
      .catch(err => console.log(err));

    // this.setState({
    //   name: '',
    //   code: '',
    //   startDate: '',
    //   endDate: '',
    //   showModal: false,
    //   schoolYearId: ''
    // })
    this.closeModal();
  }

  getDaysOfSchool= (id) => {
    axios.get(process.env.REACT_APP_URL+'/schoolYears/'+id+'/days')
    .then(response => {
      this.setState({
        jun: response.data.junDays,
        jul: response.data.julDays,
        aug: response.data.augDays,
        sep: response.data.sepDays,
        oct: response.data.octDays,
        nov: response.data.novDays,
        dec: response.data.decDays,
        jan: response.data.janDays,
        feb: response.data.febDays,
        mar: response.data.marDays,
        apr: response.data.aprDays,
        may: response.data.mayDays,
        total: response.data.totalDays,
        forSubmission: false
      });
    })
    .catch(function (error) {
      // handle error
      console.log(error);
      // this.setState({forSubmission: true})
    })
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  componentDidMount() {
    this.setState({
      name: this.props.schoolYear.name,
      code: this.props.schoolYear.code,
      startDate: moment(this.props.schoolYear.startDate).format('YYYY-MM-DD'),
      endDate: moment(this.props.schoolYear.endDate).format('YYYY-MM-DD'),
      schoolYearId: this.props.schoolYear.schoolYearId
    }, this.getDaysOfSchool(this.props.schoolYear.schoolYearId))
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      name: newProps.schoolYear.name,
      code: newProps.schoolYear.code,
      startDate: moment(newProps.schoolYear.startDate).format('YYYY-MM-DD'),
      endDate: moment(newProps.schoolYear.endDate).format('YYYY-MM-DD'),
      schoolYearId: newProps.schoolYear.schoolYearId
    }, this.getDaysOfSchool(newProps.schoolYear.schoolYearId))
  }

  render() {

    return (
      <Modal
        trigger={
          <Button icon size='tiny' onClick={this.openModal}>
            <Icon name='eye' />
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>{this.state.name} ({this.state.code}) <span className='school-year-date-range'>{moment(this.state.startDate).format('MMM YYYY')} - {moment(this.state.endDate).format('MMM YYYY')}</span></Modal.Header>
        <Modal.Content>
          <Form>
            {
              this.state.forSubmission ?
              <h3>Fill up number of days per month</h3>
              :
              <h3>Update number of days per month</h3>
            }
            <Form.Group widths='equal'>
              <Form.Field control={Input} width={1} value={this.state.aug} name='aug' label='Aug'  onChange={this.handleChange}/>
              <Form.Field control={Input} width={1} value={this.state.sep} name='sep' label='Sep'  onChange={this.handleChange}/>
              <Form.Field control={Input} width={1} value={this.state.oct} name='oct' label='Oct'  onChange={this.handleChange}/>
              <Form.Field control={Input} width={1} value={this.state.nov} name='nov' label='Nov'  onChange={this.handleChange}/>
              <Form.Field control={Input} width={1} value={this.state.dec} name='dec' label='Dec'  onChange={this.handleChange}/>
              <Form.Field control={Input} width={1} value={this.state.jan} name='jan' label='Jan'  onChange={this.handleChange}/>
              <Form.Field control={Input} width={1} value={this.state.feb} name='feb' label='Feb'  onChange={this.handleChange}/>
              <Form.Field control={Input} width={1} value={this.state.mar} name='mar' label='Mar'  onChange={this.handleChange}/>
              <Form.Field control={Input} width={1} value={this.state.apr} name='apr' label='Apr'  onChange={this.handleChange}/>
              <Form.Field control={Input} width={1} value={this.state.may} name='may' label='May'  onChange={this.handleChange}/>
              <Form.Field control={Input} width={1} value={this.state.jun} name='jun' label='Jun'  onChange={this.handleChange}/>
              <Form.Field control={Input} width={1} value={this.state.jul} name='jul' label='Jul'  onChange={this.handleChange}/>
              <Form.Field control={Input} width={1} value={this.state.total} name='total' label='Total'  disabled onChange={this.handleChange}/>
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.handleSubmit()}>Submit</Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default SchoolYearsView;
